module.exports = __webpack_public_path__ + "img/google-play.370112da.svg";